export const loadScript = async (scriptUrl, id) => {
  // Find existing script by both URL and ID to avoid conflicts
  const existingScripts = document.querySelectorAll(`script[id="${id}"]`)
  let existingScript = null

  // Check if any existing script matches both the ID and URL
  for (let i = 0; i < existingScripts.length; i++) {
    if (existingScripts[i].src === scriptUrl) {
      existingScript = existingScripts[i]
      break
    }
  }

  if (existingScript) {
    return Promise.resolve()
  }

  const script = document.createElement('script')
  script.src = scriptUrl
  script.type = 'text/javascript'
  if (id) { script.id = id }
  document.head.appendChild(script)

  return new Promise((resolve, reject) => {
    script.onload = () => {
      resolve()
    }
    script.onerror = () => {
      reject(new Error('Script loading failed: ' + scriptUrl))
    }
  })
}